module.exports = __webpack_public_path__ + "img/1.ee086d83.jpg";